import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { InputMessageType } from './types';
import { fontSmoothing } from '../../../mixins';

export const StyledMessage = styled.div<{
  type: InputMessageType;
  disabled: boolean;
}>`
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'InputMessage', 'type'))};
  ${({ disabled, theme }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colors.gray.light};
    `};
  ${css((props) =>
    ThemeUtilities.getComponentCSSOverrides(props, 'InputMessage')
  )};

  ${fontSmoothing};
`;
